import React from 'react';
import PropTypes from 'prop-types';
import AInputField from './_atoms.input-field';
import AIconButton from './_atoms.icon-button';

export default class ASearchField extends React.Component {
	constructor(props) {
		super(props);

		this.state = { value: props.value };
		this.bindHandles();
	}

	bindHandles() {
		this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	handleChange(value) {
		this.setState({ value });

		if (this.props.onChange) {
			this.props.onChange(value);
		}
	}

	handleClick() {
		if (this.props.onClick) {
			this.props.onClick(this.state.value);
		}
	}

	render() {
		return (
			<div className="a-search-field">
				<AInputField
					id={this.props.id}
					type="search"
					className={`a-field ${this.props.className}`}
					value={this.state.value}
					placeholder={this.props.placeholder}
					error={this.props.error}
					onChange={this.handleChange}
				/>
				<AIconButton
					type="search"
					onClick={this.handleClick}
				/>
			</div>
		);
	}
}

ASearchField.propTypes = {
	id: PropTypes.string.isRequired,
	className: PropTypes.string,
	error: PropTypes.bool,
	value: PropTypes.string,
	placeholder: PropTypes.string,
	onChange: PropTypes.func,
	onClick: PropTypes.func,
};

ASearchField.defaultProps = {
	className: '',
	error: false,
	value: undefined,
	placeholder: '',
	onChange: undefined,
	onClick: undefined,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.search-field.js